/**
 * AadharEditModal — thin wrapper around OtpVerificationModal in edit mode.
 * Kept as a separate file so existing imports don't break.
 */
import React from "react";
import OtpVerificationModal from "../OtpVerificationModal";

const AadharEditModal = (props) => (
  <OtpVerificationModal {...props} mode="edit" />
);

export default AadharEditModal;
